<template>
  <CollapsibleLinks>
    <template #trigger="{ toggle }">
      <a
        class="font-bold text-primary hover:text-primary-dark text-lg"
        @click.stop.prevent="toggle"
        >{{ $t("branding.about") }}</a
      >
    </template>
    <div class="flex flex-col mb-3 gap-1 text-sm">
      <NuxtLink
        v-if="notCzechOrGerman"
        :to="localePath({ name: 'aboutUs' }) + '#impressum'"
        class="text-white"
      >
        {{ $t("footer.aboutus") }}
      </NuxtLink>
      <NuxtLink
        v-if="notCzechOrGerman"
        :to="localePath({ name: 'careerPage' })"
        class="text-white"
        >{{ $t("footer.carreer") }}</NuxtLink
      >
      <NuxtLink
        :to="localePath({ name: 'blogLandingPage' })"
        class="text-white"
      >
        {{ $t("footer.blog") }}
      </NuxtLink>
      <NuxtLink
        :to="localePath({ name: 'questionsPage' })"
        class="text-white"
        >{{ $t("footer.questions") }}</NuxtLink
      >
      <a
        v-if="!$branding.isJoszaki"
        href="https://joszaki.hu"
        target="_blank"
        class="text-white"
      >
        {{ $t("footer.joszaki") }}
      </a>
      <a
        v-if="!$branding.isSuperprofikCz"
        href="https://superprofik.cz"
        target="_blank"
        class="text-white"
      >
        {{ $t("footer.superprofik") }}
      </a>
      <a
        v-if="!$branding.isBerufExperten"
        href="https://berufexperten.de"
        target="_blank"
        class="text-white"
      >
        {{ $t("footer.berufexperten") }}
      </a>
      <NuxtLink
        v-if="!$branding.isSuperprofikCz"
        :to="localePath({ name: 'inspirationLandingPage' })"
        class="text-white"
        >{{ $t("footer.inspirations") }}</NuxtLink
      >
    </div>
  </CollapsibleLinks>
</template>

<script>
import CollapsibleLinks from "./CollapsibleLinks.vue";

export default {
  components: { CollapsibleLinks },
  computed: {
    notCzechOrGerman() {
      return !this.$branding.isSuperprofikCz && !this.$branding.isBerufExperten;
    },
  },
};
</script>
